import { Validators } from "@angular/forms";
import moment = require("moment");
import { ITableKey } from "src/app/modules/shared/components/basic-table/basic-table.constants";
import { IFormKey } from "src/app/modules/shared/models/forms";

export const residence_enabling_map = {
  stato: 'provincia',
  provincia: 'localita',
  localita: 'cap',
  cap: 'indirizzo',
  indirizzo: 'civico',
}

export const PREVIDENTIAL_ADDRESS_TABLE_KEYS: ITableKey[] = [
  {
    key: 'indirizzo',
    label: 'Indirizzo',
  },
  {
    key: 'localita',
    label: 'Località',
  },
  {
    key: 'provincia',
    label: 'Provincia',
  },
  {
    key: 'cap',
    label: 'C.A.P.',
  },
  {
    key: 'c_nazione',
    label: 'Nazione',
  },
  {
    key: 'tipo_indirizzo',
    label: 'Tipo di indirizzo',
  }
];

export interface IResidenceChangeRequest {
  policyNumber: string;
  cap: string;
  street: string;
  location: string;
  province: string;
  country: string;
  personType: string;
  userId?: string;
  referenceDate?: string;
  sameAddress?: boolean;
  n_indirizzo_alternativo?: number;
}

export const residence_change_previdence_form_template = {
  stato: null,
  provincia: null,
  localita: null,
  cap: null,
  indirizzo: null,
  civico: null,
  effectDate: moment(),
  sameAddress: null,
}

export const residence_change_previdence_form_validators = {
  stato: [Validators.required],
  provincia: [Validators.required],
  localita: [Validators.required],
  cap: [Validators.required],
  indirizzo: [Validators.required],
  civico: [Validators.required],
  effectDate: [Validators.required],
  sameAddress: null
}

export const residence_change_previdence_form_group_config: IFormKey[] = [
  {
    id: 'country-field',
    label: 'Nazione',
    controlName: 'stato',
    css: 'col-4',
    type: 'SELECT'
  },
  {
    id: 'province-field',
    label: 'Provincia',
    controlName: 'provincia',
    css: 'col-4',
    type: 'SELECT'
  },
  {
    id: 'place-field',
    label: 'Località',
    controlName: 'localita',
    css: 'col-4',
    type: 'SELECT'
  },
  {
    id: 'cap-field',
    label: 'CAP',
    controlName: 'cap',
    css: 'col-4',
  },
  {
    id: 'address-field',
    label: 'Indirizzo',
    controlName: 'indirizzo',
    css: 'col-4',
  },
  {
    id: 'civic-field',
    label: 'Civico',
    controlName: 'civico',
    css: 'col-4',
  },
  {
    id: 'effect-date-field',
    label: 'Data Effetto Variazione',
    controlName: 'effectDate',
    css: 'col-4',
    type: 'DATEPICKER',
    minDate: moment()
  },
  {
    id: 'same-residence-field',
    label: 'Stesso indirizzo di residenza',
    controlName: 'sameAddress',
    css: 'col-3',
    type: 'CHECKBOX'
  }
]
